module.exports = __webpack_public_path__ + "img/04_stylii_conc_silver.6ef7c2e6.png";